import React from 'react';
import { Redirect, RedirectProps } from 'react-router-dom';
import { withAnalyticOnView } from 'react-shisell';
import { compose } from 'recompose';
import mixpanelClient from 'packages/smart-home-support/api/mixpanelClient';
import { handleAdobePageAnalytics } from 'packages/smart-home-support/utils';

const EVENT_NAME = 'SCH_ValCalcRedirect_PageView';

const ValueCalculatorRedirect: React.FC = () => {
  mixpanelClient.track(EVENT_NAME);
  handleAdobePageAnalytics();
  const redirect: RedirectProps = {
    to: {
      pathname: '/',
      hash: 'val-calc-section',
    },
  };
  return <Redirect push={false} {...redirect} />;
};

export default compose(
  withAnalyticOnView({
    analyticName: EVENT_NAME,
    mapPropsToExtras: (props) => {
      return {
        Tags: ['atlas'],
        SendAsCommonEvent: true,
      };
    },
  })
)(ValueCalculatorRedirect);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/valcalcredirect/index.tsx